export const MenuItems = [
  {
    title: "Profile",
    path: "/dashboard",
    cName: "dropdown-link",
  },
  {
    title: "Logout",
    cName: "dropdown-link",
  },
];
